import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useCreateDeal } from '../mutations/useCreateDeal';
import errorHandler from '../../../gqlCommon/service/errorHandler';
import {
  GetCarSpecifications,
  GetCarSpecificationsVariables,
} from '../../graphql/queries/__generated__/GetCarSpecifications';
import carSpecifications from '../../../gqlCustomise/graphql/queries/carSpecifications';
import { JourneyType } from '../../../__generated__/globalTypes';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';
import submitCarToUrlService from '../../service/submitCarToUrlService';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { ICarDetails } from '../../../../../common/model/ICarDetails';
import useCustomizeCarContext from '../useCustomizeCarContext';

const useSubmitCarToUrlData = () => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const [carConfiguration, setCarConfiguration] = useState<ICarDetails>();
  const [dealDataLoaded, setDealDataLoaded] = useState(false);
  const { selectedCar } = useCustomizeCarContext();
  const { createNewDeal } = useCreateDeal();
  const carId = selectedCar?.car?.code;

  const { data: specificationData, error } = useQuery<GetCarSpecifications, GetCarSpecificationsVariables>(
    carSpecifications.GET_CAR_SPECIFICATIONS,
    {
      skip: !carId,
      variables: {
        carId,
      },
    },
  );

  useEffect(() => {
    (async () => {
      try {
        if (specificationData && selectedCar && !dealDataLoaded) {
          const createDealResponse = await createNewDeal(JourneyType.continue_in_dealership);
          const dealData = createDealResponse.data.createDealFromCarId;
          setDealDataLoaded(!!dealData);
          const carConfiguration = submitCarToUrlService.createCarConfiguration(
            dealData,
            selectedCar,
            specificationData.carSpecifications,
            priceDisplay,
          );
          setCarConfiguration(carConfiguration);
        }
      } catch (e) {
        errorHandler.handleError(e);
      }
    })();
  }, [specificationData, selectedCar]);

  useErrorHandler(error);

  return carConfiguration;
};

export default useSubmitCarToUrlData;
